<h2 mat-dialog-title style="position: relative;
top: -8px;">
  <span class="material-icons-outlined">
    <mat-icon style="color: #D7263D;
    font-size: 16px;
    position: relative;
    bottom: -2px;">
    error_outline
  </mat-icon>
  </span>
  ERROR
</h2>
<mat-divider></mat-divider>

<mat-icon pointer (click)="closeDialog()" style="position:relative; bottom:38px; left:94%; color:#707070">close</mat-icon>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close style="position: relative;
  left: 76%;
  top: 85px;
  width: 100px;
  height: 45px;
  border: white;
  background: #0076BB;">OK</button>
</mat-dialog-actions>